export const TRANSLATIONS_ES_HOME_PULSE_AND_CALENDAR = {
  "home.pulse.eyebrow": "Motor de clasificación en vivo",
  "home.pulse.subtitle": "Supervisamos cómo Innovadoc IA etiqueta y entiende tus documentos en este momento.",
  "home.pulse.originNote": "Estas lecturas alimentan las fechas, prioridades y acciones que ves en el resto del home.",
  "home.pulse.state.ok": "Todo en calma",
  "home.pulse.state.processing": "Atención requerida",
  "home.pulse.state.attention": "Crítico",
  "home.pulse.summary.documents": "Documentos ya interpretados",
  "home.pulse.summary.artifacts": "Tipos entendidos",
  "home.pulse.summary.categories": "Categorías reconocidas",
  "home.pulse.summary.overdue": "Vencidos",
  "home.pulse.summary.upcoming": "Próximos",
  "home.pulse.modal.eyebrow": "Fechas clave",
  "home.pulse.modal.overdueTitle": "Documentos vencidos",
  "home.pulse.modal.upcomingTitle": "Documentos próximos",
  "home.pulse.modal.countLabel": "Mostrando",
  "home.pulse.modal.ofLabel": "de",
  "home.pulse.modal.dueLabelOverdue": "Venció",
  "home.pulse.modal.dueLabelUpcoming": "Vence",
  "home.pulse.modal.roleLabel": "Rol",
  "home.pulse.modal.stateLabel": "Estado",
  "home.pulse.modal.actionLabel": "Acción",
  "home.pulse.modal.close": "Cerrar",
  "home.pulse.modal.viewDocument": "Ver documento",
  "home.pulse.modal.openQueue": "Ver pendientes",
  "home.pulse.modal.overdueEmpty": "No hay documentos vencidos.",
  "home.pulse.modal.upcomingEmpty": "No hay documentos próximos.",
  "home.pulse.modal.limitedHint": "Lista resumida. Ve tus pendientes para verlo todo.",
  "home.pulse.artifactTypes.title": "Tipos de artefacto detectados",
  "home.pulse.artifactTypes.showMore": "Ver más",
  "home.pulse.artifactTypes.showLess": "Ver menos",
  "home.pulse.recentClassifications.title": "Clasificaciones recientes",
  "home.pulse.recentClassifications.countLabel": "registros",
  "home.pulse.recentClassifications.empty": "Sin clasificaciones en la última hora.",
  "home.pulse.empty": "No hay datos de pulso disponibles.",
  "home.datesSummary.eyebrow": "Fechas importantes",
  "home.datesSummary.title": "Fechas importantes de tus documentos",
  "home.datesSummary.totalLabel": "documentos con fechas próximas",
  "home.datesSummary.description": "Vencimientos y plazos próximos que conviene no perder de vista.",
  "home.datesSummary.connection": "Ordenadas por lo que vence antes.",
  "home.datesSummary.roleLabel": "Responsable",
  "home.datesSummary.role.renewal": "Renovaciones",
  "home.datesSummary.role.audit": "Auditorías",
  "home.datesSummary.role.expiration": "Vencimientos",
  "home.datesSummary.role.compliance": "Cumplimiento",
  "home.datesSummary.tooltip": "Detectadas automáticamente en tus documentos.",
  "home.datesSummary.clearFilter": "Limpiar filtro por rol",
  "home.datesSummary.panelEyebrow": "Fechas importantes",
  "home.datesSummary.panelTitle": "Fechas importantes de tus documentos",
  "home.datesSummary.panelSubtitle": "Documentos y sus fechas próximas que conviene revisar.",
  "home.datesSummary.closePanel": "Cerrar panel de fechas",
  "home.datesSummary.panelQueueCta": "Ver estos documentos",
  "home.datesSummary.panelFilterActive": "Filtro activo: mostrando solo este rol.",
  "home.datesSummary.panelEmpty": "No hay fechas detectadas para mostrar.",
  "home.datesSummary.empty": "No hay fechas detectadas por ahora.",
  "home.datesSummary.filterSaved": "Preferencia guardada.",
  "home.datesSummary.state.active": "Activo",
  "home.datesSummary.state.upcoming": "Próximo",
  "home.datesSummary.state.resolved": "Resuelto",
  "home.datesSummary.previewTitle": "Próximas fechas",
  "home.datesSummary.previewSubtitle": "por cercanía",
  "home.datesSummary.previewAction": "Ver lista",
  "home.datesSummary.previewChangeRole": "Cambiar responsable",
  "home.datesSummary.previewOpenCalendar": "Abrir calendario",
  "home.stats.title": "Cómo entiende hoy tus documentos",
  "home.stats.description": "Seguimos estas métricas para validar que la clasificación se mantenga saludable.",
  "home.stats.note": "Respaldan cada recomendación y tus pendientes.",
  "home.stats.label.pending_documents": "Documentos pendientes",
  "home.stats.label.evaluated_documents": "Documentos evaluados",
  "home.stats.label.oldest_pending_age_seconds": "Antigüedad del pendiente más antiguo (segundos)",
  "home.stats.label.last_evaluation_age_seconds": "Antigüedad de la última evaluación (segundos)",
  "home.stats.label.evaluation_duration_p95_ms": "Duración evaluación p95 (ms)",
  "home.stats.label.evaluation_duration_p99_ms": "Duración evaluación p99 (ms)",
  "home.stats.label.ranker_duration_p95_ms": "Duración ranker p95 (ms)",
  "home.stats.label.ranker_duration_p99_ms": "Duración ranker p99 (ms)",
  "home.stats.label.error_rate": "Tasa de error",
  "home.stats.label.throughput_eval_per_hour": "Evaluaciones por hora",
  "home.stats.label.throughput_rank_per_hour": "Ranking por hora",
  "home.stats.empty": "Aún no hay métricas disponibles.",
  "home.decisionPulse.eyebrow": "Pulso operativo",
  "home.decisionPulse.headline.alert": "Hay decisiones que requieren atención inmediata",
  "home.decisionPulse.headline.watch": "La carga está estable, pero conviene anticiparse",
  "home.decisionPulse.headline.calm": "Todo está bajo control por ahora",
  "home.decisionPulse.copy.actNow": "requieren acción inmediata",
  "home.decisionPulse.copy.overdue": "vencidas",
  "home.decisionPulse.copy.actSoon": "deberían resolverse pronto",
  "home.decisionPulse.copy.monitoring": "decisiones siguen en monitoreo",
  "home.decisionPulse.copy.empty": "No hay decisiones activas en este momento.",
  "home.decisionPulse.connection.label": "SSE",
  "home.decisionPulse.connection.connecting": "Conectando",
  "home.decisionPulse.connection.connected": "En tiempo real",
  "home.decisionPulse.connection.disconnected": "Desconectado",
  "home.decisionPulse.connection.error": "Con retraso",
  "home.knowledgeExpirations.title": "Próximos vencimientos documentales",
  "home.knowledgeExpirations.viewAll": "Ver todos",
  "home.knowledgeExpirations.empty": "No hay vencimientos próximos en tus documentos.",
  "home.knowledgeExpirations.errorTitle": "No se pudieron cargar los vencimientos",
  "home.knowledgeExpirations.errorMessage": "Inténtalo de nuevo en unos segundos.",
  "home.knowledgeEntities.title": "Entidades con actividad reciente",
  "home.knowledgeEntities.viewAll": "Explorar",
  "home.knowledgeEntities.sources": "fuentes",
  "home.knowledgeEntities.empty": "Aún no hay entidades con actividad reciente.",
  "home.knowledgeEntities.errorTitle": "No se pudieron cargar las entidades",
  "home.knowledgeEntities.errorMessage": "Inténtalo de nuevo en unos segundos.",
  "home.calendar.eyebrow": "Calendario",
  "home.calendar.title": "Calendario de decisiones",
  "home.calendar.description": "Explora decisiones por fecha operativa sin salir del detalle existente.",
  "home.calendar.empty": "No hay decisiones con fecha para este rango.",
  "home.calendar.emptyMonth": "Sin decisiones fechadas",
  "home.calendar.undated": "Decisiones sin fecha",
  "home.calendar.today": "Hoy",
  "home.calendar.previous": "Anterior",
  "home.calendar.next": "Siguiente",
  "home.calendar.moreEntries": "más",
  "home.calendar.emptyDay": "No hay eventos monitoreados este día.",
  "home.calendar.granularity.week": "Semana",
  "home.calendar.granularity.month": "Mes",
  "home.calendar.granularity.year": "Año",
  "home.calendar.agenda.empty": "No hay decisiones programadas en este mes.",
  "home.calendar.agenda.today": "Hoy",
  "home.calendar.agenda.todayBadge": "Hoy",
  "home.calendar.agenda.previousMonth": "Mes anterior",
  "home.calendar.agenda.nextMonth": "Mes siguiente",
  "home.viewMode.label": "Modo de vista",
};
